const ORDER_API_FIELDS = [
  "name",
  "phone",
  "location",
  "categories",
  "locationOnMap",
  "notes",
  "priority",
  "status",
  "meters",
];

const PICTURE_FILE_FIELD = "pictures";
const DELETED_PICTURE_IDS_FIELD = "deletedPictureIds[]";

const isFile = (value) => (
  typeof File !== "undefined" && value instanceof File
);

// Example: pictureFiles with preview metadata -> only actual File objects.
const getPictureFiles = (order = {}) => (
  Array.isArray(order.pictureFiles) ? order.pictureFiles.filter(isFile) : []
);

// Example: [10, null, 12] -> [10, 12].
const getDeletedPictureIds = (order = {}) => (
  Array.isArray(order.deletedPictureIds) ? order.deletedPictureIds.filter(Boolean) : []
);

// Example: added files or deleted IDs -> true, otherwise the request can stay JSON.
const hasPictureChanges = (order = {}) => (
  getPictureFiles(order).length > 0 || getDeletedPictureIds(order).length > 0
);

// Example: strips UI-only fields like pictureFiles before sending JSON.
const buildOrderJsonPayload = (order = {}) => {
  const payload = {};

  ORDER_API_FIELDS.forEach((field) => {
    if (Object.prototype.hasOwnProperty.call(order, field)) {
      payload[field] = order[field];
    }
  });

  return payload;
};

// Example: categories ["kitchen", "office"] -> repeated categories[] form fields.
const appendFormValue = (formData, field, value) => {
  if (field === "categories") {
    const categories = Array.isArray(value) ? value : [];

    categories.forEach((category) => {
      formData.append("categories[]", category);
    });

    return;
  }

  if (typeof value === "boolean") {
    formData.append(field, value ? "true" : "false");
    return;
  }

  if (value !== undefined && value !== null) {
    formData.append(field, value);
  }
};

// Example: no picture edits -> plain object; picture edits -> FormData with pictures/deletedPictureIds[].
export const buildOrderRequest = (order = {}) => {
  const jsonPayload = buildOrderJsonPayload(order);

  if (!hasPictureChanges(order)) {
    return jsonPayload;
  }

  const formData = new FormData();
  const pictureFiles = getPictureFiles(order);
  const deletedPictureIds = getDeletedPictureIds(order);

  Object.entries(jsonPayload).forEach(([field, value]) => {
    appendFormValue(formData, field, value);
  });

  pictureFiles.forEach((file) => {
    formData.append(PICTURE_FILE_FIELD, file);
  });

  deletedPictureIds.forEach((pictureId) => {
    formData.append(DELETED_PICTURE_IDS_FIELD, pictureId);
  });

  return formData;
};
